import BerthingInfo from './berthing-info.component'

export default BerthingInfo